import styled from '@emotion/styled';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { Small, H5 } from '../type';
import { COLORS, GLOBAL, SPACE, FONT_SIZE } from '../../constants';

const StyledTableContainer = styled(TableContainer)`
  &.MuiTableContainer-root {
    overflow: visible;

    table {
      border-collapse: separate;
      border-spacing: 0;
    }
  }
`;

const StyledTableHead = styled(TableHead)`
  &.MuiTableHead-root {
    border: 0;
  }
`;

const StyledTableBody = styled(TableBody)`
  &.MuiTableBody-root {
    position: relative;
    background-color: ${COLORS.WHITE};
    filter: drop-shadow(0 2px 11px ${COLORS.GREY_FOUR});
  }
`;

const StyledItemRow = styled(TableRow)`
  &.MuiTableRow-root {
    cursor: pointer;

    &:focus {
      /* This approach to applying border styles is necessary since Safari has issues rendering outlines and borders on table elements */
      & td {
        border-top: 2px solid ${COLORS.BRAND_BLUE_EIGHT};
        border-bottom: 2px solid ${COLORS.BRAND_BLUE_EIGHT};
      }

      & td:first-child {
        border-left: 2px solid ${COLORS.BRAND_BLUE_EIGHT};
      }

      & td:last-child {
        border-right: 2px solid ${COLORS.BRAND_BLUE_EIGHT};
      }
    }

    &.Mui-selected {
      background-color: ${COLORS.WHITE};

      & > * {
        color: ${COLORS.BRAND_BLUE_NINE};
      }
    }
  }
`;

const StyledVehicleDescriptionHeader = styled(H5)`
  font-size: ${FONT_SIZE.X_LARGE};
`;

const StyledHeaderCell = styled(TableCell)`
  &.MuiTableCell-root {
    padding-left: 0;
    padding-bottom: ${SPACE.X1};
    border: 0;
  }
`;

const StyledItemCell = styled(TableCell)`
  &.MuiTableCell-root {
    position: relative;
    border: 0;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 1px;
      background-color: ${COLORS.GREY_FOUR};
    }

    ${StyledItemRow}:last-child & {
      &::after {
        display: none;
      }
    }
  }
`;

const StyledCellText = styled(Small)`
  font-family: ${GLOBAL.BRAND_FONT_FAMILY_SECOND};
  font-size: ${FONT_SIZE.MEDIUM_SMALL};
`;

export {
  StyledCellText,
  StyledItemCell,
  StyledHeaderCell,
  StyledItemRow,
  StyledTableBody,
  StyledTableContainer,
  StyledTableHead,
  StyledVehicleDescriptionHeader,
};
